import {
  LOGIN_USER_LOADING,
  LOGIN_USER_FAILURE,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER_SUCCESS,
  LOGOUT_USER_LOADING,
  LOGOUT_USER_FAILURE,
  OTP_USER_LOADING,
  OTP_USER_SUCCESS,
  OTP_USER_FAILURE,
  REFRESH_TOKEN_REQUEST,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_FAILURE,
} from "./user.action.Types";
import axios from "axios";
import { loginUserApi, logoutUserApi, otpUserApi } from "./user.auth.api";
import jwt_decode from "jwt-decode";
import { BASE_URL_USER } from "../App/action";

export const userLogin = (data) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_USER_LOADING });
    let res = await loginUserApi(data);
    localStorage.setItem("id", res.requestId);
    dispatch({
      type: LOGIN_USER_SUCCESS,
      payload: { token: res.token, data: res.message },
    });
  } catch (err) {
    dispatch({ type: LOGIN_USER_FAILURE });
  }
};

export const userOtp = (data) => async (dispatch) => {
  try {
    dispatch({ type: OTP_USER_LOADING });
    let res = await otpUserApi(data);
    console.clear(res);
    localStorage.setItem("token", res.data?.payload?.token?.accessToken?.token);
    localStorage.setItem(
      "refresh",
      res.data?.payload?.token?.refreshToken?.token,
    );
    localStorage.setItem(
      "expiry",
      res.data?.payload?.token?.accessToken?.expire,
    );
    const profileUpdated = res.data?.payload?.token?.accessToken?.token;
    const decoded = jwt_decode(profileUpdated);
    const checker = decoded.isProfileUpdated;
    dispatch({
      type: OTP_USER_SUCCESS,
      payload: {
        token: res.data?.payload?.token?.accessToken?.token,
        data: checker,
      },
    });
  } catch (err) {
    dispatch({ type: OTP_USER_FAILURE });
  }
};

export const logoutUser = (data) => async (dispatch) => {
  try {
    dispatch({ type: LOGOUT_USER_LOADING });
    let res = await logoutUserApi(data);
    dispatch({ type: LOGOUT_USER_SUCCESS, payload: res });
  } catch (err) {
    dispatch({ type: LOGOUT_USER_FAILURE });
  }
};

export const refreshTokenRequest = () => ({ type: REFRESH_TOKEN_REQUEST });
export const refreshTokenSuccess = (newAccessToken) => ({
  type: REFRESH_TOKEN_SUCCESS,
  payload: { newAccessToken },
});
export const refreshTokenFailure = () => ({ type: REFRESH_TOKEN_FAILURE });

export const refreshAccessToken = (refreshToken) => async (dispatch) => {
  dispatch(refreshTokenRequest());

  try {
    const response = await axios.get(`${BASE_URL_USER}/public-api/v1/token`, {
      headers: {
        "Content-Type": "application/json",
        token: `Bearer ${refreshToken}`,
      },
    });

    const newAccessToken = response.data.payload.token.accessToken.token;
    console.log(`newAccessToken`, newAccessToken);
    dispatch(refreshTokenSuccess(newAccessToken));
  } catch (error) {
    console.error("Error refreshing access token:", error);
    dispatch(refreshTokenFailure());
  }
};
